import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const metricasPorOperador = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.SUPERVISOR.METRICAS.TURNOS_POR_OPERADOR}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default metricasPorOperador;